import React from 'react'
import { useIsMobileQuery } from 'src/hooks/useMediaQuery'
import classNames from 'classnames'
import IcomoonReact from 'icomoon-react'
import PropTypes from 'prop-types'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import elementStyles from './elements.module.scss'
import layoutStyles from 'src/components/Layout/layouts.module.scss'
import HorizontalLine from './HorizontalLine'

const TypeProps = {
  title: PropTypes.string,
  closeModal: PropTypes.func.isRequired
}

const AlertModal = ({ title, closeModal, children }) => {
  const isMobileSize = useIsMobileQuery()
  return (
    <div data-testid="alertModal" className={layoutStyles.alertModalOverlayContainer}>
      <div
        className={classNames(
          elementStyles.alertContainer,
          isMobileSize && elementStyles.alertContainerMobile
        )}
      >
        <div className={elementStyles.alertBody}>
          <div className={elementStyles.closeContainer}>
            <button
              data-testid="alertModalCloseButton"
              className={classNames(
                elementStyles.iconContainer,
                elementStyles.closeButton
              )}
              onClick={closeModal}
            >
              <IcomoonReact
                iconSet={rebrandIconSet}
                size={24}
                icon="Controls-X"
              />
            </button>
          </div>
          <div data-testid="alertModalHeader" className={elementStyles.alertHeaderContainer}>
            <div className={elementStyles.alertText}>
              <span className={fontStyles.pdefaultboldlsgraphik18pt}>
                {title}{' '}
              </span>
            </div>
            <div className={generalStyles.mt20} />
            <HorizontalLine color="c03silvere8e8e8" fullWidth />
          </div>
          <div className={classNames(elementStyles.alertContentContainer)}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

AlertModal.propTypes = {
  ...TypeProps
}

export default AlertModal
